export const toKebabCase = (...parts: Array<string | undefined | null>) =>
  parts.filter((p) => p && p !== '').join('-');
